import refs from '../helpers/refs'

class CInstructionManualsAccordion {
  constructor (el) {
    this.$root = el
    this.$refs = refs(this.$root)

    this.init()
  }

  init () {
    this.$root.querySelectorAll('[data-accordion]').forEach((el) => {
      el.querySelector('[data-toggle]').addEventListener('click', () => {
        el.classList.toggle('active')
      })
    })
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('.c-instruction-manuals-accordion')
    .forEach(el => new CInstructionManualsAccordion(el))
})
